import React from 'react';
import { LatestDetection } from '../../../../LiveContext/NewSessionContext/Contexts/SessionDetectionContextProvider/useSessionDetectionContext';

export interface DetectionGroup {
  id: string,
  title: string,
  lastOccurrence: number,
  projectId: string;
  detections: (LatestDetection & { cardTitle?: string, commandTitle?: string, isIntention?: boolean })[],
  displayedAt?: number,
  notificationBadge?: { seen: boolean },
}

const DetectionGroupContext = React.createContext<DetectionGroup[] | null>(null);

export default DetectionGroupContext;
